// One file per area so areas can be translated independently. Each exports
// { en, es, pt }; en is the source and defines the keys, es/pt may lag
// (missing keys fall back to English).
import { hub } from "./hub";
import { nav } from "./nav";
import { paywall } from "./paywall";
import { pricing } from "./pricing";
import { studio } from "./studio";
import { studioOptions } from "./studioOptions";
import { auth } from "./auth";
import { checkout } from "./checkout";
import { upsell } from "./upsell";

const AREAS = [
  hub,
  nav,
  paywall,
  pricing,
  studio,
  studioOptions,
  auth,
  checkout,
  upsell,
] as const;

export const en = Object.assign(
  {},
  ...AREAS.map((a) => a.en),
) as typeof hub.en &
  typeof nav.en &
  typeof paywall.en &
  typeof pricing.en &
  typeof studio.en &
  typeof studioOptions.en &
  typeof auth.en &
  typeof checkout.en &
  typeof upsell.en;
export type MessageKey = keyof typeof en;
type Dict = Partial<Record<MessageKey, string>>;
export const es: Dict = Object.assign({}, ...AREAS.map((a) => a.es));
export const pt: Dict = Object.assign({}, ...AREAS.map((a) => a.pt));
